(() => {
  const form = document.querySelector('[data-cart-form]');
  const deliveryButton = form?.querySelector('[data-delivery-start]');
  if (!form || !deliveryButton) return;

  deliveryButton.addEventListener('click', async event => {
    event.preventDefault();
    deliveryButton.disabled = true;
    const originalLabel = deliveryButton.textContent;
    deliveryButton.textContent = 'Saving cart';

    const updates = {};
    form.querySelectorAll('input[name^="updates["]').forEach(input => {
      const key = input.name.slice(8, -1);
      updates[key] = Number.parseInt(input.value, 10) || 0;
    });

    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ updates })
      });

      if (!response.ok) throw new Error('Cart update failed');
      window.location.assign(deliveryButton.dataset.deliveryUrl || '/pages/delivery');
    } catch (requestError) {
      deliveryButton.disabled = false;
      deliveryButton.textContent = originalLabel;
      const status = form.querySelector('[data-cart-delivery-error]');
      if (status) {
        status.textContent = 'We could not save your cart. Please try again.';
        status.hidden = false;
      }
    }
  });
})();
